import React from "react";

type WidthGuideProps = {
  lineLeft: number;
  dragging?: boolean;
};

export function WidthGuide({ lineLeft, dragging }: WidthGuideProps) {
  return (
    <div
      className={"email-builder-image-resize-width-guide"}
      data-dragging={dragging ? 'true' : undefined}
      style={{ left: lineLeft }}
      aria-hidden
    />
  );
}
